import React, {useEffect, useState} from "react"
import {NavLink, useNavigate} from "react-router-dom"

import "./MyPage.css"

import MyNav from "../../component/Nav/MyNav"
import RightFooter from "../../component/Footer/RightFooter"
import {getDateTimeStr, numberWithCommas, retrieveData, sendRequest} from "../../common";

function MyPage() {
	const navigate = useNavigate()

	const [user, setUser] = useState({})
	const [payments, setPayments] = useState([])

	const getPayments = () => {
		sendRequest('order/payment/?isMy=1', 'GET', null, data => {
			setPayments(data)
		})
	}

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
		})
		getPayments()
	}, [])

	return (
		<>
			<MyNav />
			<div className="container">
				<div className="myContent">
					<div className="header">
						<h3>마이페이지</h3>
					</div>
					<div className="myWrap">
						<section className="myPage">
							<div className="buy">
								<h4>{user?.name?.slice(0, 1) + '*' + user?.name?.slice(2)}({user?.isExpert ? '전문가 회원' : '개인회원'})님은 PTS 심리유형 검사 구매 가능합니다.</h4>
								<button type="button" onClick={(e) => {
									e.preventDefault()
									navigate('/purchase-online')
								}}>구매하기</button>
							</div>
							<div className="aboutBtn">
								<button
									type="button"
									onClick={() => {
										navigate("/personal-code/send-complete")
									}}>
									실시 결과 조회
								</button>
								<button
									className="keyBtn"
									type="button"
									onClick={() => {
										navigate("/personal-result")
									}}>
									검사 결과 조회
								</button>
							</div>
							<div className="tableTitle">
								<h4>최근 주문내역</h4>
								<button
									type="button"
									onClick={() => {
										navigate("/my-page/order")
									}}>
									전체 보기
								</button>
							</div>
							<div className="myTableWrap">
								<table className="myTable">
									<thead>
										<tr>
											<th>주문일자</th>
											<th>주문번호</th>
											<th>주문상품</th>
											<th>주문총액</th>
											<th>결제상황</th>
											<th>매출전표</th>
											<th>처리상황</th>
										</tr>
									</thead>
									<tbody>
										{payments?.map((item, index) => {
											return (
												<tr>
													<td>{getDateTimeStr(new Date(item?.createdDate))}</td>
													<td className="orderNumber">{item?.order?.orderNumber}</td>
													<td className="alignLt">{item?.order?.orderProducts?.map((item) => item?.product?.name).toString()}</td>
													<td>{numberWithCommas(item?.price)}원</td>
													<td className="complete">{item?.order?.status}</td>
													<td>
														<button type="button" className="download" onClick={() => {
															window.open(`https://iniweb.inicis.com/DefaultWebApp/mall/cr/cm/mCmReceipt_head.jsp?noTid=${item?.paymentNumber}&noMethod=1`)
														}}>
															다운로드
														</button>
													</td>
													<td className="complete">{item?.resultCode === 'paid' ? '처리완료': '처리대기'}</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
						</section>
					</div>
				</div>
			</div>
			<RightFooter />
		</>
	)
}

export default MyPage
